import { TaskDataWithIdDto, TaskStatusDto } from '@/api/generated';
import {
  resourceTypeTranslation,
  ResourceTypeTranslation,
  taskStatusOptionsTranslation,
  TaskStatusOptionsTranslation,
} from '@/assets/locales/utils/dictionaries/dictionaries.translation.pl.ts';
import { TaskDetailsTab } from '@/views/tasks/details/model/TaskDetailsTab.enum.ts';

export type TaskDetailsTranslation = {
  header: {
    button: {
      edit: string;
    };
  };
  main: Record<
    keyof Omit<
      TaskDataWithIdDto,
      | 'contextResourceId'
      | 'contextResourceType'
      | 'createdFromTemplate'
      | 'lastModificationAt'
      | 'modifiedBy'
      | 'requiredStatusCode'
      | 'taskId'
      | 'title'
    >,
    string
  > & {
    contextResourceTypeOptions: ResourceTypeTranslation;
    goTo: string;
    nextStatus: TaskStatusOptionsTranslation;
    statusOptions: TaskStatusOptionsTranslation;
  };
  messages: {
    button: {
      addMessage: string;
    };
    title: string;
  };
  tabs: Record<TaskDetailsTab, string>;
  tabsNotes: string;
};

export const taskDetailsTranslation: TaskDetailsTranslation = {
  header: {
    button: {
      edit: 'Edytuj',
    },
  },
  main: {
    assignedUser: 'Przypisane do',
    completionMode: 'Tryb zakończenia',
    contextResourceTypeOptions: resourceTypeTranslation,
    createdAt: 'Data utworzenia',
    creatorUser: 'Utworzone przez',
    description: 'Opis',
    dueDate: 'Termin zadania',
    goTo: 'Przejdź do',
    hidden: 'Prywatne',
    nextStatus: {
      [TaskStatusDto.Canceled]: 'Anuluj',
      [TaskStatusDto.Done]: 'Zakończ',
      [TaskStatusDto.DoneNotConfirmed]: 'Zakończ (niepotwierdzone)',
      [TaskStatusDto.InProgress]: 'Rozpocznij',
      [TaskStatusDto.New]: 'Wróć do początku',
      [TaskStatusDto.Postponed]: 'Odłóż',
      [TaskStatusDto.Rejected]: 'Odrzuć',
    },
    originalDueDate: 'Pierwotny termin zadania',
    status: 'Status',
    statusOptions: taskStatusOptionsTranslation,
    watchersUsers: 'Obserwatorzy',
  },
  messages: {
    button: {
      addMessage: 'Dodaj wiadomość',
    },
    title: 'Wiadomości',
  },
  tabs: {
    [TaskDetailsTab.FILES]: 'Pliki',
    [TaskDetailsTab.MAILS_AND_NOTES]: 'Maile i notatki',
    [TaskDetailsTab.MESSAGES]: 'Wiadomości',
  },
  tabsNotes: 'Notatki',
};
